import { defineMessages } from 'react-intl';

export default defineMessages({
    completingYourPurchaseMessage: {
        id: 'endorsement.eh.policyChangeDiffPage.Completing your purchase...',
        defaultMessage: 'Completing your purchase...'
    },
    issue: {
        id: 'endorsement.eh.policyDiffPage.Issue',
        defaultMessage: 'Issue'
    },
    loadingPolicyDiff: {
        id: 'endorsement.eh.policyChangeDiffPage.Loading...',
        defaultMessage: 'Loading...'
    },
    policyChangePhraseTitle: {
        id: 'endorsement.eh.policyChangeDiffPage.Change Phrases',
        defaultMessage: 'Change Phrases'
    },
    changesPhrases: {
        id: 'endorsement.eh.policyDiffPage.Change Phrases',
        defaultMessage: 'Change Phrases'
    },
    differences: {
        id: 'endorsement.eh.policyChangeDiffPage.tab.Differences',
        defaultMessage: 'Differences'
    },
    changeConflict: {
        id: 'endorsement.eh.policyChangeDiffPage.tab.Change Conflicts',
        defaultMessage: 'Change Conflicts'
    },
    signature: {
        id: 'endorsement.eh.policyChangeDiffPage.tab.Signature',
        defaultMessage: 'Signature'
    },
    withdrawPolicyChange: {
        id: 'e1p.policychangediff.eh.gateway.views.endorsement-detail.Withdraw Policy Change',
        defaultMessage: 'Withdraw Policy Change'
    },
    mayWithDrawPolicyChange: {
        id: 'e1p.gateway.policychangediff.eh.views.endorsement-detail.You may withdraw the policy change',
        defaultMessage: 'You may withdraw the policy change'
    },
    withdraw: {
        id: 'e1p.policychangediff.eh.gateway.views.endorsement.Withdraw',
        defaultMessage: 'Withdraw'
    },
    modalError: {
        id: 'e1p.gateway.policychangediff.eh.views.modal.Error',
        defaultMessage: 'Error'
    },
    failedToWithdrawPolicyChange: {
        id: 'e1p.gateway.policychangediff.eh.views.endorsement-detail.Failed to withdraw policy change',
        defaultMessage: 'Failed to withdraw policy change'
    }
});
